import type { SkeletonLoaderProps } from './SkeletonLoader.interfaces';

export default function SkeletonLoader({ additionalClassNames = '' }: SkeletonLoaderProps) {
  return <div className={`c-skeleton-loader ${additionalClassNames}`} aria-hidden={true} />;
}
